import React, { useLayoutEffect, useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Questions = (props) => {
  const { activeKey, faqs } = props;
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const translations = useSelector((state) => state.translation.translations);

  const headingFormatter = () => {
    let heading;
    translations.forEach((translation) => {
      if (
        activeKey === translation.translationKey &&
        translation.language.toLowerCase() === currentLanguage
      ) {
        heading = translation.translationValue;
      }
    });
    return heading;
  };

  const contentFormatter = () => {
    let faqQA = new Array();
    faqs.forEach((faq) => {
      if (faq.translationKey === activeKey) {
        faqQA = [...faqQA, ...faq.faQs];
        return;
      }
    });

    return faqQA;
  };

  const faqQFormatter = (key) => {
    let question;
    translations.forEach((translation) => {
      if (
        key === translation.translationKey &&
        translation.language.toLowerCase() === currentLanguage
      ) {
        question = translation.translationValue;
        return;
      }
    });
    return question;
  };

  const faqAFormatter = (key) => {
    let answer;
    translations.forEach((translation) => {
      if (
        key === translation.translationKey &&
        translation.language.toLowerCase() === currentLanguage
      ) {
        answer = translation.translationValue;
        return;
      }
    });
    return answer;
  };

  return (
    <Box as="section" className="faq-question-container">
      <Typography className="faq-heading" fontSize={"2.9rem"} fontWeight={700}>
        {headingFormatter()}
      </Typography>
      {contentFormatter().map((faq, index) => (
        <Accordion key={index} className="questions-accordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="questions-accordion-summary"
          >
            <Typography color="#444660" fontSize={"1.2rem"} fontWeight={600}>
              {faqQFormatter(faq.translationQuestionKey)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="questions-accordion-details">
            <Typography>{faqAFormatter(faq.translationAnswerKey)}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default Questions;
